export default __webpack_public_path__ + "media/images/ui-icons_ffffff_256x240-74e9fe3d.png";